import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from '@hyperkit'; 

import { HuntContextService } from '../../../../../services/hunt-context.service'


export interface TableColumn {
  header: string;
  field: string;
}

@Component({
  selector: 'default-query-logic-tab',
  imports: [CommonModule, BannerComponent],
  templateUrl: './query-logic-tab.component.html',
  styleUrl: './query-logic-tab.component.scss',
})
export class QueryLogicTabComponent {
    readonly hunt = inject(HuntContextService);
    
    readonly columns: TableColumn[] = [
      { header: 'Selection', field: 'selection' },
      { header: 'Field', field: 'field' },
      { header: 'Value', field: 'value' }
    ];
    
    readonly huntQueryLogic = this.hunt.queryPackages.queryTable;


}
